import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router } from '@angular/router';

import { TranslateModule } from '@ngx-translate/core';

import { ButtonComponent, IconComponent } from '@shared/components';
import { ROUTES } from '@shared/models';

@Component({
  selector: 'rp-home-cta',
  standalone: true,
  templateUrl: './cta.component.html',
  styleUrl: './cta.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateModule, ButtonComponent, IconComponent],
})
export class CtaComponent {
  private readonly _router = inject(Router);

  navigateToSignUp(): void {
    this._router.navigate([ROUTES.signUp]);
  }
}
